import React, { useMemo } from 'react';

import { usePageContent } from '~/App/shared/hooks/use-page-content';

import { loadData } from './SelfTestResult.LoadData';
import { SelfTestResult } from './SelfTestResult';

const View = (props: any) => {
  const pageContent = usePageContent();

  const children = useMemo(
    () => (pageContent ? <SelfTestResult {...pageContent} {...props} /> : null),
    [pageContent, props]
  );

  return children;
};

View.loadData = loadData;

export default View;
